<div id="snackbar"></div>

<body class="grey lighten-3">
    <div class="bar">
        <div class="row-container">
            <div>
                <a href="/login">
                    <img src="/assets/unipet_text.png" width="180px" style="margin-left: 20px">
                </a>
            </div>

            <div class="site-title">
                VENDOR REGISTRATION PORTAL
            </div>
    
            <div class="right-side">
                <a class="help-link" (click)="openLightbox(tutorialVideoUrl)">
                    <span class="help-icon">?</span>
                    <span class="help-text">Tutorial</span>
                </a>
                <span class="divider">|</span>
                <a href="https://unipet.co.tt/procurement/" target="_blank"> Contact Us</a>
                <span class="divider">|</span>
                <a href="/login" class="admin-nav-link fixed-bottom" routeLinkActive="active">LOGIN</a>
            </div>
        </div>
    </div>
    

  <br>
  <br>
  <br>
  <br>
  <br>
  <br>

  <div class="white panel-card form-container">
    <div *ngIf="!submissionsSettingsLoaded" class="overlay">
      <div class="spinner"></div>
    </div>

    <div *ngIf="submissionsSettingsLoaded && submissionsRestricted" class="submissions-closed">
      <div class="submissions-closed-card" role="status" aria-live="polite">
        <div class="submissions-closed-icon" aria-hidden="true">
          <i class="material-icons">event_busy</i>
        </div>
        <h4 class="submissions-closed-title">Registrations Temporarily Closed</h4>
        <p class="submissions-closed-lead">
          We're not accepting new submissions at this time.
        </p>
        <p class="submissions-closed-detail">
          If you already have an account, sign in to access the vendor portal and continue your registration.
        </p>
        <a routerLink="/login" class="submissions-closed-login">Sign In to Portal</a>
        <p class="submissions-closed-hint">
          You can also use <strong>LOGIN</strong> in the top-right corner of this page.
        </p>
      </div>
    </div>

    <ng-container *ngIf="submissionsSettingsLoaded && !submissionsRestricted">
    <h4 class="left-align">Hi Vendor,</h4><br>
    <h6 class="subtext left-align">Welcome to the UNIPET's Vendor Registration Portal. To get started, please enter your email address. <br> If you've already begun a form, be sure to use the same email to continue. </h6>

    <div *ngIf="loading" class="overlay">
        <div class="spinner"></div>
    </div>

    <div class="row error" style="margin-top: 50px;" [innerHTML]="error_message">
      <!-- <p class="error">{{error_message}}</p> -->
    </div>
    <p class="status-message">{{ statusMessage }}</p>

  
    <form class="auth-form" (ngSubmit)="emailChecked ? (isNewUser ? signup() : login()) : checkEmail()">
      <input type="email" [(ngModel)]="email" name="email" placeholder="Email" (ngModelChange)="resetErrorMessage()" required />

      <ng-container *ngIf="emailChecked">
        <div *ngIf="!isNewUser" class="password-fields">
            <!-- <div class="password-wrapper"> -->
              <input
                class="password-input"
                (ngModelChange)="resetErrorMessage()"
                [type]="hidePassword ? 'password' : 'text'"
                [(ngModel)]="password"
                name="password"
                placeholder="Password"
                required
              />
              <!-- <i
                class="material-icons password-visibility"
                (click)="hidePassword = !hidePassword">
                {{ hidePassword ? 'visibility' : 'visibility_off' }}
              </i> -->
            <!-- </div> -->
            <div class="links">
                <a (click)="hidePassword = !hidePassword" class="forgot-link">{{ hidePassword ? 'Show Password' : 'Hide Password' }}</a>
                <a [routerLink]="'/reset_password'" class="forgot-link">Forgot Password?</a>
            </div>
        </div>
          
          
  
        <div *ngIf="isNewUser" class="password-fields"> 
          <input type="password" 
          [(ngModel)]="createPassword" (ngModelChange)="checkPasswordRequirements()" name="createPassword" placeholder="Create Password" required />
          
          <!-- Password Requirements Checklist -->
          <div class="password-checklist" *ngIf="createPassword">
            <div class="checklist-item" [ngClass]="{'met': passwordRequirements.hasMinLength, 'unmet': !passwordRequirements.hasMinLength}">
              <i class="material-icons checklist-icon">{{ passwordRequirements.hasMinLength ? 'check_circle' : 'radio_button_unchecked' }}</i>
              <span>At least 8 characters</span>
            </div>
            <div class="checklist-item" [ngClass]="{'met': passwordRequirements.hasUppercase, 'unmet': !passwordRequirements.hasUppercase}">
              <i class="material-icons checklist-icon">{{ passwordRequirements.hasUppercase ? 'check_circle' : 'radio_button_unchecked' }}</i>
              <span>One uppercase letter</span>
            </div>
            <div class="checklist-item" [ngClass]="{'met': passwordRequirements.hasNumber, 'unmet': !passwordRequirements.hasNumber}">
              <i class="material-icons checklist-icon">{{ passwordRequirements.hasNumber ? 'check_circle' : 'radio_button_unchecked' }}</i>
              <span>One number</span>
            </div>
            <div class="checklist-item" [ngClass]="{'met': passwordRequirements.hasSpecialChar, 'unmet': !passwordRequirements.hasSpecialChar}">
              <i class="material-icons checklist-icon">{{ passwordRequirements.hasSpecialChar ? 'check_circle' : 'radio_button_unchecked' }}</i>
              <span>One special character (!&#64;#$%^&*)</span>
            </div>
          </div>

          <input type="password" 
          [(ngModel)]="confirmPassword"  (ngModelChange)="resetErrorMessage()" name="confirmPassword" placeholder="Confirm Password" required />
        </div>
        
      </ng-container>
      

      <div class="button-wrapper">
        <i *ngIf="emailChecked" class="material-icons back-icon" (click)="resetEmailCheck()">arrow_back</i>
        <button type="submit" class="auth-button" [disabled]="error_message !== ''">
          {{ emailChecked ? (isNewUser ? 'Sign Up' : 'Login') : 'Continue' }}
        </button>
      </div>      
      </form>


    <p class="tutorial-link" (click)="openLightbox(tutorialVideoUrl)">
      Click here for Tutorial 🎥
    </p>
    </ng-container>

    <div *ngIf="isLightboxOpen" class="lightbox" (click)="closeLightbox()">
        <div class="lightbox-content" (click)="$event.stopPropagation()">
            <span class="lightbox-close" (click)="closeLightbox()">×</span>
            <iframe
                [src]="selectedVideoUrl"
                frameborder="0"
                allowfullscreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin">
            </iframe>
        </div>
    </div>
  </div>
  <br>
</body>